export default __webpack_public_path__ + "static/media/lookinfoxxy.4e7f3cc6.png";